import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLinkWithHref } from '@angular/router';

import { Observable, Subscription } from 'rxjs';

import { PatientService, AuthService } from '@Services';
import { Demographic, User } from '@Models';

import { gpPatientPageNavigation, hvPatientPageNavigation, snPatientPageNavigation } from '@Constants';

@Component({
  selector: 'app-patient-navigation',
  imports: [RouterLinkWithHref, NgIf, NgClass, AsyncPipe],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.css',
})
export class PatientNavigationComponent implements OnInit, OnDestroy {
  currentUrl: string | null = null;
  url: string | null = null;
  private routerSubscription: Subscription | null = null;

  demographic$: Observable<Demographic | null> | null = null;

  user: User | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _patientService: PatientService,
    private _authService: AuthService,
  ) {
    this._authService.user$.subscribe((user) => {
      this.user = user;
    });
  }

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.url = this.removeLastPart(this.router.url);

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateUrls(event.urlAfterRedirects);
      }
    });

    this.demographic$ = this._patientService.demographic(this.route.snapshot.params['guid']);
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private updateUrls(url: string): void {
    this.currentUrl = url;
    this.url = this.removeLastPart(url);
  }

  private removeLastPart(url: string): string {
    const parts = url.split('/');
    if (parts.length > 2 && parts[parts.length - 2] === 'vaccinations') {
      parts.pop(); // Remove the last part
      parts.pop(); // Remove the second-to-last part
    } else {
      parts.pop(); // Remove the last part
    }
    return parts.join('/');
  }

  isUrlMatch(endpoints: string[]): boolean {
    if (!this.currentUrl) {
      return false;
    }
    const currentEndpoint = this.currentUrl.split('/').pop();
    return endpoints.includes(currentEndpoint || '');
  }

  shouldDisplayNavItem(item: string): boolean {
    switch (this.user?.role) {
      case 'gp':
      case 'pd':
        return gpPatientPageNavigation.includes(item);
      case 'hv':
      case 'sg':
        return hvPatientPageNavigation.includes(item);
      case 'sn':
        return snPatientPageNavigation.includes(item);
      default:
        return false;
    }
  }
}
